import { LANGUAGE } from '@epilot/journey-logic-commons/src/types/next'
import { useEffect } from 'react'

import { instance18n, loadRemoteNamespace } from '../locales/i18n'
import { selectJourneyLanguage } from '../store/selectors/config'

import { useAppStoreSelector } from './useAppStoreSelector'

export const useLanguage = (override?: LANGUAGE) => {
  const journeyLanguage = useAppStoreSelector(selectJourneyLanguage)

  useEffect(() => {
    const value = override ?? journeyLanguage ?? LANGUAGE.DE

    instance18n.changeLanguage(value)
    loadRemoteNamespace(value)
    // updates the html tag
    document.documentElement.lang = value
  }, [journeyLanguage, override])
}
